<script>
  import { onMount } from "svelte";
  import swal from "sweetalert";

  const URL = "https://bluesky-api.now.sh/";
  const COMMAND = "getrandomdata";
  let literaryWork = null;
  let textTitle = "";
  let author = "";
  let mainText = "";
  let textIndex = 0;
  let isCompleted = false;
  onMount(() => {
    fetch(URL + COMMAND, {
      method: "GET",
      mode: "cors",
      cache: "no-cache"
    })
      .then(res => {
        console.log(res);
        if (res.ok) {
          return res.json();
        }
        return Promise.reject(new Error("取得失敗."));
      })
      .then(res => {
        console.log(res);
        literaryWork = res;
        textTitle = literaryWork.title;
        author = literaryWork.author;
        setTweetMessage(textTitle, author);
      })
      .catch(err => {
        console.log(err);
        return err;
      });
  });
  /**
   * ツイートボタン押下時のツイート内容を動的に変更
   * @param {*} title 作品タイトル
   * @param {*} author 著者
   */
  function setTweetMessage(title, author) {
    const tweetMessage =
      author + " 著" + "「" + title + "」" + "を書いたフリをしました！";

    //ツイートボタンのDOM生成
    const tweetBtn = document.getElementById("tweet");
    tweetBtn.innerHTML =
      '<a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-size="large"data-text="' +
      tweetMessage +
      '" data-hashtags="スーパー作家ー">Tweet</a>';

    //ツイートボタン再構築
    twttr.widgets.load();
  }

  let touchStartTime;
  /**
   * 画面タッチ開始イベント
   * @param {*} event イベント
   */
  function touchStart(event) {
    //タッチ終了イベントが呼ばれるまでの時間を計るため、現在時刻を保持
    touchStartTime = new Date();
  }
  /**
   * 画面タッチ終了イベント
   * @param {*} event イベント
   */
  function touchEnd(event) {
    //タッチ終了までの時間が指定時間以内であれば文章出力を行う
    const now = new Date();
    if (now - touchStartTime > 150) {
      return;
    }
    write(event);
  }

  /**
   * 文章出力
   * @param {*} event イベント
   */
  function write(event) {
    if (!literaryWork || isCompleted) {
      return;
    }
    const text = literaryWork.mainText;
    const cutNum = Math.round(Math.random() * 3) + 2;
    const str = text.substr(textIndex, cutNum);
    mainText += str;
    textIndex += cutNum;

    const element = document.documentElement;
    const bottom = element.scrollHeight - element.clientHeight;
    window.scroll(0, bottom);

    if (mainText === text) {
      isCompleted = true;
    }
  }

  function help(event) {
    swal(
      "このサイトについて",
      "何かしらの小説が書けます。小説は、青空文庫に掲載されている著作権切れの作品からランダムに抽出されます。",
      "info"
    );
  }
</script>

<style>
  .wrapper {
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

  header {
    height: 48px;
    line-height: 48px;
    background-color: royalblue;
    box-shadow: 0px 5px 3px lightslategrey;
    padding: 0px 10px;
    color: white;

    display: flex;
    justify-content: space-between;
  }
  header .left {
    display: flex;
    align-items: center;
  }
  header .left span {
    margin-left: 5px;
  }
  .help {
    display: flex;
  }
  .help img {
    fill: white;
  }
  header .right {
    display: flex;
    align-items: center;
    width: 95px;
  }

  .description {
    text-align: center;
    padding-top: 10px;
  }
  @media screen and (max-width: 480px) {
    .text {
      font-size: 0.8em;
    }
  }
  .container {
    flex-grow: 1;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .paper {
    flex-grow: 1;
    margin: 0 10px;
    margin-bottom: 20px;
    max-width: 640px;
    background-image: url("../assets/paper-background.jpg");
    padding: 10px;
    box-shadow: 1px 1px 7px rgb(160, 160, 160);

    font-family: "Sawarabi Mincho";
    font-size: 1.1em;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .paper .textTitle {
    text-align: center;
  }

  pre {
    white-space: pre-wrap;
    line-height: 1.5em;
    font-family: "Sawarabi Mincho";
  }
</style>

<svelte:window on:keypress={write} />
<main class="wrapper">
  <header>
    <div class="left">
      <a href="#a" on:click={help} class="help">
        <img src="help-24px.svg" alt="help" />
      </a>
      <span>スーパー作家ー</span>
    </div>
    <div class="right" id="tweet" />
  </header>
  <div class="description">
    <span class="text">
      作品タイトル表示後、キーボード連打で小説が書けます。
      <br />
      (スマートフォンなら画面の用紙タップ)
    </span>
  </div>
  {#if literaryWork}
    <div class="quote">
      <span class="text">
        引用元：
        <a href={literaryWork.url}>{author} {textTitle}(青空文庫)</a>
      </span>
    </div>
  {/if}
  <div class="container">
    <div class="paper" on:touchstart={touchStart} on:touchend={touchEnd}>
      <h2 class="textTitle">{textTitle}</h2>
      <div>
        <pre>{mainText}</pre>
      </div>
    </div>
  </div>
</main>
